import { useState } from "react";

import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui";

import { ExpandedBundleItem, type ExpandedBundleItemProps } from "../ExpandedBundleItem";

export const BundleLineItem = (props: ExpandedBundleItemProps) => {
  const { __ } = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <ExpandedBundleItem {...props} areBundleItemsShown={isExpanded} areBundlePricesEnabled={isExpanded} />
      <Button size="sm" variant="text" aria-expanded={isExpanded} onClick={() => setIsExpanded((prev) => !prev)}>
        {isExpanded
          ? __("cart.items_summary.hide_bundle_items", [props.subItems.length])
          : __("cart.items_summary.view_bundle_items", [props.subItems.length])}
      </Button>
    </>
  );
};
